export enum MixpanelEvent {
  SAFE_APP_LAUNCHED = 'Safe App Launched',
  SAFE_CREATED = 'Safe Created',
  SAFE_ACTIVATED = 'Safe Activated',
  WALLET_CONNECTED = 'Wallet Connected',
  POSITION_EXPANDED = 'Position Expanded',
  POSITIONS_VIEW_ALL_CLICKED = 'Positions View All Clicked',
  EMPTY_POSITIONS_EXPLORE_CLICKED = 'Empty Positions Explore Clicked',
  PORTFOLIO_REFRESH_CLICKED = 'Portfolio Refresh Clicked',
  STAKE_VIEWED = 'Stake Viewed',
  EARN_VIEWED = 'Earn Viewed',
  WC_CONNECTED = 'WC Connected',
  CSV_TX_EXPORT_CLICKED = 'Export CSV Clicked',
  CSV_TX_EXPORT_SUBMITTED = 'CSV Exported',
  NATIVE_SWAP_VIEWED = 'Native Swap Viewed',
  SIDEBAR_CLICKED = 'Sidebar Clicked',
  GUARDIAN_BANNER_VIEWED = 'Guardian Banner Viewed',
  GUARDIAN_FORM_VIEWED = 'Guardian Form Viewed',
  GUARDIAN_FORM_STARTED = 'Guardian Form Started',
  GUARDIAN_FORM_SUBMITTED = 'Guardian Form Submitted',
  SECURITY_REPORT_CLICKED = 'Security Report Clicked',
  GUARDIAN_BANNER_DISMISSED = 'Guardian Banner Dismissed',
  EXPLORE_POSSIBLE_CLICKED = 'Explore Possible Clicked',
  EURCV_BOOST_EXPLORE_CLICKED = 'EURCV Boost Explore Clicked',
  EURCV_BOOST_BANNER_CLICKED = 'EURCV Boost Banner Clicked',
  EURCV_BOOST_BANNER_DISMISSED = 'EURCV Boost Banner Dismissed',
  SAFE_PRO_BANNER_CLICKED = 'Safe Pro Banner Clicked',
  TRANSACTION_STARTED = 'Transaction Started',
  TRANSACTION_RECIPIENT_DECODED = 'Transaction Recipient Decoded',
  TRANSACTION_CONTRACT_DECODED = 'Transaction Contract Decoded',
  TRANSACTION_THREAT_ANALYZED = 'Transaction Threat Analyzed',
  TRANSACTION_SIMULATED = 'Transaction Simulated',
  TRANSACTION_EXECUTED = 'Transaction Executed',
  TRANSACTION_EXECUTED_VIA_PARENT = 'Transaction Executed Via Parent',
  TRANSACTION_EXECUTED_IN_PARENT = 'Transaction Executed In Parent',
  TRANSACTION_EXECUTED_VIA_ROLE = 'Transaction Executed Via Role',
  TRANSACTION_SUBMITTED = 'Transaction Submitted',
  TRUSTED_SAFE_ADDED = 'Trusted Safe Added',
  TRUSTED_SAFE_REMOVED = 'Trusted Safe Removed',
  HYPERNATIVE_LOGIN_CLICKED = 'Hypernative Login Clicked',
  HYPERNATIVE_CONNECTED = 'Hypernative Connected',
  HYPERNATIVE_FULL_REPORT_CLICKED = 'Hypernative Full Report Clicked',
  FALSE_RESULT_REPORTED = 'False Result Reported',
  WORKSPACE_DASHBOARD_VIEWED = 'Workspace Dashboard Viewed',
  AUTH_LOGIN_SUCCEEDED = 'Auth Login Succeeded',
  AUTH_LOGIN_FAILED = 'Auth Login Failed',
  AUTH_LOGGED_OUT = 'Auth Logged Out',
  WORKSPACE_CREATED = 'Workspace Created',
  WORKSPACE_MEMBER_INVITE_SENT = 'Workspace Member Invite Sent',
  WORKSPACE_MEMBER_INVITE_ACCEPTED = 'Workspace Member Invite Accepted',
  WORKSPACE_MEMBER_ROLE_CHANGED = 'Workspace Member Role Changed',
  WORKSPACE_MEMBER_REMOVED = 'Workspace Member Removed',
  WORKSPACE_MEMBER_INVITE_DECLINED = 'Workspace Member Invite Declined',
  SAFE_SELECTED = 'Safe Selected',
  CHAIN_SWITCHED = 'Chain Switched',
  WORKSPACE_SAFE_LINK_STARTED = 'Workspace Safe Link Started',
  WORKSPACE_SAFE_LINKED = 'Workspace Safe Linked',
  WORKSPACE_SAFE_UNLINKED = 'Workspace Safe Unlinked',
  ACCOUNTS_WIDGET_CLICKED = 'Accounts Widget Clicked',
  PENDING_TX_WIDGET_CLICKED = 'Pending TX Widget Clicked',
  WALLET_SWITCHED = 'Wallet Switched',
  WALLET_DISCONNECTED = 'Wallet Disconnected',
  WORKSPACE_CREATE_STARTED = 'Workspace Create Started',
  WORKSPACE_SWITCHED = 'Workspace Switched',
  ADDRESS_BOOK_ENTRY_CREATED = 'Address Book Entry Created',
  WORKSPACE_TRANSACTION_INITIATED = 'Workspace Transaction Initiated',
  ONBOARDING_WIZARD = 'Onboarding Wizard',
  USE_OLD_UI = 'Use Old UI',
  ERROR_SURFACED = 'Error Surfaced',
  WORKSPACE_UPDATED = 'Workspace Updated',
  WORKSPACE_DELETED = 'Workspace Deleted',
  WORKSPACE_LEFT = 'Workspace Left',
  WORKSPACE_MEMBER_INVITE_RENEWED = 'Workspace Member Invite Renewed',
  WORKSPACE_ACCOUNTS_ADDED = 'Workspace Accounts Added',
  WORKSPACE_ACCOUNT_ADDED_MANUALLY = 'Workspace Account Added Manually',
  WORKSPACE_ACCOUNT_DELETED = 'Workspace Account Deleted',
  WORKSPACE_SEND_TX_STARTED = 'Workspace Send Tx Started',
  WORKSPACE_ADDRESS_EDITED = 'Workspace Address Edited',
  WORKSPACE_ADDRESS_REMOVED = 'Workspace Address Removed',
  WORKSPACE_ADDRESS_BOOK_IMPORTED = 'Workspace Address Book Imported',
  WORKSPACE_ADDRESS_REQUEST_SENT = 'Workspace Address Request Sent',
  WORKSPACE_ADDRESS_REQUEST_APPROVED = 'Workspace Address Request Approved',
  WORKSPACE_ADDRESS_REQUEST_REJECTED = 'Workspace Address Request Rejected',
  WORKSPACE_LOCAL_CONTACT_ADDED = 'Workspace Local Contact Added',
  SECURITY_HUB_VIEWED = 'Security Hub Viewed',
  SECURITY_REPORT_OPENED = 'Security Report Opened',
  ACTIVITY_LOG_VIEWED = 'Activity Log Viewed',
  ACTIVITY_LOG_FILTERED = 'Activity Log Filtered',
  POLICY_CATALOGUE_TILE_CLICKED = 'Policy Catalogue Tile Clicked',
  POLICY_UPSELL_UPGRADE_CLICKED = 'Policy Upsell Upgrade Clicked',
  ADD_POLICY_DIALOG_CLOSED = 'Add Policy Dialog Closed',
  PROPOSER_SUBMITTED = 'Proposer Submitted',
  SPENDING_LIMIT_SET = 'Spending Limit Set',
  SPENDING_LIMIT_TX_CONFIRMED = 'Spending Limit Tx Confirmed',
  SPENDING_LIMIT_TX_SIGNED = 'Spending Limit Tx Signed',
  SAFE_PRO_BANNER_VIEWED = 'Safe Pro Banner Viewed',
  FREE_ACCESS_OFFER_VIEWED = 'Free Access Offer Viewed',
  FREE_ACCESS_CLAIM_CLICKED = 'Free Access Claim Clicked',
  FREE_ACCESS_OFFER_DISMISSED = 'Free Access Offer Dismissed',
  SAFE_ACCOUNT_SELECTION_VIEWED = 'Safe Account Selection Viewed',
  SAFE_ACCOUNT_SELECTION_SUBMITTED = 'Safe Account Selection Submitted',
  WORKSPACE_CREATE_STEP_VIEWED = 'Workspace Create Step Viewed',
  PLAN_SELECTION_STARTED = 'Plan Selection Started',
  PLANS_PAGE_VIEWED = 'Plans Page Viewed',
  PLAN_CTA_CLICKED = 'Plan CTA Clicked',
  PLAN_CHANGE_CONFIRMED = 'Plan Change Confirmed',
  CHECKOUT_STARTED = 'Checkout Started',
  CHECKOUT_RETURNED = 'Checkout Returned',
  FREE_ACCESS_REMINDER_VIEWED = 'Free Access Reminder Viewed',
  WORKSPACE_LOCKED_VIEWED = 'Workspace Locked Viewed',
  UPGRADE_PROMPT_VIEWED = 'Upgrade Prompt Viewed',
}

export enum WorkspaceCreateEntryPoint {
  WELCOME = 'welcome',
  SIDEBAR = 'sidebar',
  EMPTY_STATE = 'empty_state',
}

export enum PlanSelectionEntryPoint {
  SIDEBAR = 'sidebar',
  REMINDER_MODAL = 'reminder_modal',
  LOCKED_MODAL = 'locked_modal',
  UPGRADE_PROMPT = 'upgrade_prompt',
  DIRECT = 'direct',
}

export enum FreeAccessEntryPoint {
  WORKSPACE_LOGIN = 'workspace_login',
  CREATE_WORKSPACE = 'create_workspace',
}

export enum UpgradeFeature {
  POLICIES = 'policies',
  PROPOSERS = 'proposers',
  SPENDING_LIMITS = 'spending_limits',
  SAFE_SHIELD_CHECKS = 'safe_shield_checks',
  SPONSORED_TX = 'sponsored_tx',
  SAFE_ACCOUNTS_LIMIT = 'safe_accounts_limit',
}

export enum UpgradeLocation {
  POLICIES_PAGE = 'policies_page',
  SETTINGS_SETUP = 'settings_setup',
  TX_FLOW_SAFE_SHIELD = 'tx_flow_safe_shield',
  TX_FLOW_GAS = 'tx_flow_gas',
  SAFE_ACCOUNTS_PAGE = 'safe_accounts_page',
}

/** Where a plan can be chosen or compared. */
export enum PlanLocation {
  PLANS_PAGE = 'plans_page',
  REMINDER_MODAL = 'reminder_modal',
  LOCKED_MODAL = 'locked_modal',
}

export enum DismissAction {
  GO_TO_MY_ACCOUNTS = 'go_to_my_accounts',
}

export enum PlanCtaKind {
  ADD_PAYMENT_METHOD = 'add_payment_method',
  SWITCH_PLAN = 'switch_plan',
  CONTINUE_WITH_PLAN = 'continue_with_plan',
}

export enum BillingPeriod {
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}

export enum CheckoutOutcome {
  SUCCESS = 'success',
  CANCELLED = 'cancelled',
}

export enum WorkspaceCreateStep {
  CREATE_WORKSPACE = 'create_workspace',
  SELECT_SAFES = 'select_safes',
  INVITE_MEMBERS = 'invite_members',
  SURVEY = 'survey',
}

export enum MixpanelUserProperty {
  WALLET_LABEL = 'Wallet Label',
  WALLET_ADDRESS = 'Wallet Address',
  SAFE_ADDRESS = 'Safe Address',
  SAFE_VERSION = 'Safe Version',
  NUM_SIGNERS = 'Number of Signers',
  THRESHOLD = 'Threshold',
  NETWORKS = 'Networks',
  TOTAL_TX_COUNT = 'Total Transaction Count',
  LAST_TX_AT = 'Last Transaction at',
  IS_OWNER = 'Is Owner',
}

export enum MixpanelEventParams {
  APP_VERSION = 'App Version',
  BLOCKCHAIN_NETWORK = 'Blockchain Network',
  DEVICE_TYPE = 'Device Type',
  SAFE_ADDRESS = 'Safe Address',
  EOA_WALLET_LABEL = 'EOA Wallet Label',
  EOA_WALLET_ADDRESS = 'EOA Wallet Address',
  EOA_WALLET_NETWORK = 'EOA Wallet Network',
  ENTRY_POINT = 'Entry Point',
  NUMBER_OF_OWNERS = 'Number of Owners',
  THRESHOLD = 'Threshold',
  DEPLOYMENT_TYPE = 'Deployment Type',
  PAYMENT_METHOD = 'Payment Method',
  SAFE_APP_NAME = 'Safe App Name',
  SAFE_APP_TAGS = 'Safe App Tags',
  LAUNCH_LOCATION = 'Launch Location',
  PROTOCOL_NAME = 'Protocol Name',
  LOCATION = 'Location',
  AMOUNT_USD = 'Amount USD',
  TOTAL_VALUE_OF_PORTFOLIO = 'Total Value of Portfolio',
  APP_URL = 'App URL',
  DATE_RANGE = 'Date Range',
  SIDEBAR_ELEMENT = 'Sidebar Element',
  RESULT = 'Result',
  SOURCE = 'Source',
  TRANSACTION_TYPE = 'Transaction Type',
  SPACE_ID = 'Space ID',
  WORKSPACE_ID = 'Workspace ID',
  AUTH_METHOD = 'Auth Method',
  FAILURE_REASON = 'Failure Reason',
  CHAIN_ID = 'Chain ID',
  TX_ID = 'TX ID',
  SAFE_SELECTOR_DROPDOWN = 'Safe Selector Dropdown',
  GAS_PAYMENT_SOURCE = 'Gas Payment Source',
  GAS_PAYMENT_OPTION = 'Gas Payment Option',
  ERROR_DOMAIN = 'Error Domain',
  ERROR_TYPE = 'Error Type',
  ERROR_LAYER = 'Error Layer',
  ERROR_CODE = 'Error Code',
  IS_USER_FACING = 'Is User Facing',
  TARGET_CONTRACT_LABEL = 'Target Contract Label',
  TX_HASH = 'Transaction Hash',
  RPC_ENDPOINT_KIND = 'RPC Endpoint Kind',
  RPC_HOST = 'RPC Host',
  HTTP_STATUS = 'HTTP Status',
  ERROR_ATTEMPT = 'Error Attempt',
  IS_RETRY = 'Is Retry',
  ERROR_OCCURRENCES = 'Error Occurrences',
  ACCOUNT_COUNT = 'Account Count',
  ENTRY_COUNT = 'Entry Count',
  MEMBER_ROLE = 'Member Role',
  POLICY_TYPE = 'Policy Type',
  IS_AVAILABLE = 'Is Available',
  SPENDER_COUNT = 'Spender Count',
  LIMIT_COUNT = 'Limit Count',
  IS_EXECUTED = 'Is Executed',
  PLAN_STATUS = 'Plan Status',
  PLAN_TIER = 'Plan Tier',
  FREE_ACCESS_DAYS_LEFT = 'Free Access Days Left',
  FREE_ACCESS_LENGTH = 'Free Access Length',
  USER_ROLE = 'User Role',
  DESTINATION_URL = 'Destination URL',
  DISMISS_ACTION = 'Dismiss Action',
  ACCOUNTS_AVAILABLE = 'Accounts Available',
  PLAN_LIMIT = 'Plan Limit',
  SELECTED_COUNT = 'Selected Count',
  DESELECTED_COUNT = 'Deselected Count',
  STEP_NUMBER = 'Step Number',
  STEP_NAME = 'Step Name',
  BILLING_PERIOD = 'Billing Period',
  TARGET_PLAN = 'Target Plan',
  SEATS = 'Seats',
  CTA = 'CTA',
  PLAN_IS_CURRENT = 'Plan Is Current',
  FROM_PLAN = 'From Plan',
  FROM_SEATS = 'From Seats',
  TO_SEATS = 'To Seats',
  TO_PLAN = 'To Plan',
  AMOUNT_DUE = 'Amount Due',
  OUTCOME = 'Outcome',
  FEATURE = 'Feature',
  SPONSORED_REMAINING = 'Sponsored Remaining',
  SPONSORED_QUOTA = 'Sponsored Quota',
  DEFAULT_SEATS = 'Default Seats',
  DEFAULT_BILLING_PERIOD = 'Default Billing Period',
}

export enum AuthLoginMethod {
  SIWE = 'siwe',
  EMAIL_OTP = 'email_otp',
  EMAIL_GOOGLE = 'email_google',
}

export enum SafeAppLaunchLocation {
  PREVIEW_DRAWER = 'Preview Drawer',
  SAFE_APPS_LIST = 'Safe Apps List',
}

export const ADDRESS_PROPERTIES = new Set([
  MixpanelEventParams.SAFE_ADDRESS,
  MixpanelEventParams.EOA_WALLET_ADDRESS,
  MixpanelUserProperty.SAFE_ADDRESS,
])
